{
  "en": "English",
  "de": "German",
  "fr": "French",
  "es": "Spanish",
  "cs": "Czech",
  "da": "Danish",
  "et": "Estonian",
  "fi": "Finnish",
  "hr": "Croatian",
  "hu": "Hungarian",
  "it": "Italian",
  "lt": "Lithuanian",
  "lv": "Latvian",
  "nl": "Dutch",
  "nb": "Norwegian Bokmål",
  "pl": "Polish",
  "pt": "Portuguese",
  "ro": "Romanian",
  "sk": "Slovak",
  "sl": "Slovenian",
  "sq": "Albanian",
  "sv": "Swedish"
}
